import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Kemi from "../../../assets/shortlist_23/kemi.png";
import Auwal from "../../../assets/shortlist_23/auwal.png";
import Violet from "../../../assets/shortlist_23/violet.png";
import Zainab from "../../../assets/shortlist_23/zainab.png";

const solutionNominees = [
  {
    name: "Kemi Busari",
    title: "Premium Times",
    imgpath: Kemi,
  },
  {
    name: "Muhammad Auwal Ibrahim",
    title: "Freelancer",
    imgpath: Auwal,
  },
  {
    name: "Zainab Bala",
    title: "The Scoop Storytelling Initiative",
    imgpath: Zainab,
  },
  {
    name: "Violet Ikong",
    title: "Prime Progress",
    imgpath: Violet,
  },
];

const SolutionNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Solutions Journalism Award (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {solutionNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default SolutionNominees;
